module.exports = __webpack_public_path__ + "static/media/shop_type_3.b783ed82.png";